<template>
  <div>
    <div>
      <div class="study">
        <div class="study-play">
          <be-told></be-told>
        </div>
      </div>
      <div class="main">
        <div class="main-play">
          <list-of-resume></list-of-resume>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BeTold from "./components/beTold";
  import ListOfResume from "./components/listOfResume";
  export default {
    name: "Resume",
    components: {ListOfResume, BeTold},
    created() {
      console.log(12312312312312)
    }
  }
</script>

<style scoped>
  .main{
    min-height: 400px;
  }
  .study{
    width: 100%;
    height: 33px;
  }
  .study-play{
    width: 1320px;
    height: 33px;
    margin: 0 auto;
  }
  .main{
    width: 100%;
    height: 300px;
  }
  .main-play{
    width: 1060px;
    height: 300px;
    margin: 30px auto 0 auto;
    border-top: 1px solid #ccc;
    padding-top: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/resume/resume.vue